const runner = async () => {
	if (window.__IE_deprecation__) {
		return
	}

	await window.externalsRegistry.lodash.loaded
	require('./client')
}

runner()
